import { render, staticRenderFns } from "./GoodsCountDeliveryTime.vue?vue&type=template&id=724771a6"
import script from "./GoodsCountDeliveryTime.vue?vue&type=script&lang=js"
export * from "./GoodsCountDeliveryTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports